export default {
    language:'繁體中文',
    // 導航
    NEW:{
        title:"最值得信賴的數位資產交易平臺",
        title2:"獲得高達30%的現金返還和0.045%的交易費用",
        l3:"開始",
        l4:"主流區",
        l5:"創新區",
        l99:"DeFi區",   
        l6:'市場',
        l7:'幣種',
        l8:'最後成交價',
        l9:'日變化量',
        l10:'24小時最低價',
        l11:'24小時最高價',
        l12:'24小時成交量',
        l13:'買入',
        l14:'趨勢+-',
        l15:'今天就開啟您在OMGFIN的交易 ',
        l16:'登入',
        l18:'注册',
        l19:'| 交易平臺',
        l20:'最值得信賴的數位資產交易平',
        l21:'關於我們',
        l22:'關於',
        l23:'服務協定',
        l24:'隱私權聲明',
        l25:'費率標準',
        l26:'風險提示',
        l27:'AML項目',
        l28:'客戶服務',
        l29:'API檔案',
        l30:'上幣申請',
        l31:'分支機搆',
        l32:'幫助',
        l33:'客戶服務',
        l34:'郵箱: support@omgfin.com',
        l35:'社交媒體',
        l36:'頂尖的得主',
        l37:'賣出',
        s1:'委託時間',
        s2:'總額',
        s3:'價格',
        s4:'幣種',
        s5:'用戶身份證件',
        s6:'返回',
        s7:'幣種',
        s8:'委託時間',
        s9:'總額',
        s10:'價格',
        s11:'幣種',
        s12:'變換百分比',
        s13:'最後成交價',
        s14:"理財帳戶",
        s15:"申請解凍",
        s16:"記錄",
        s17:"劃轉",
        s18:"總資產",
        s19:"幣幣帳戶",
        s20:"理財帳戶",
        s21:"請輸入整數",
        s22:"凍結",
        s23:"確定解凍嗎",
        s24:"確定",
        s25:"取消",
        s26:"解凍時間",
        s27:"確定存入",
        s28:"解凍",
        s29:"以內的",
        s30:"數量"
      
        
    },
	zdy:{
        ygsy: "預估收益",
        jssj:"結束時間",
        fhjg:"發行價格",
        fhzl:"發行總量",
        gw:"官網",
        bps:"白皮書",
        sgzq:"申購周期",
        xmxq:"項目詳情",
        yr:"預熱",
        sg:"申購",
        js:"結束",
        rgcz:"認購操作",
        srrgsl:"輸入認購數量",
        rg:"認購",
        kdh:"可兌換",
        yjs:"已結束",
        wks:"未開始",
        jxz:"進行中",
        ieorg:"IEO認購",
        qbye:"錢包餘額",
        scsj:"鎖倉時間",
        cslb:"鎖倉列表",
        cs:"鎖倉",
        zqx:"已取消",    
        zwc:"已完成",
        zyz:"鎖倉中",
        syl:"收益率",
        ts:"天數",
        cbgz: "鎖倉規則",
        zywa: "質押挖礦",
        sftjmcj:"是否提交訂單賣出價",
        sftjmrj:"是否提交訂單買入價",
		proloss:'止盈止損',
        scwk:"鎖倉挖礦"
	},
    header:{
        home:'首頁',
        markets:'行情',
        fiat:'法幣交易',
        c2c:'C2C交易',
        exchange:'幣幣交易',
        lever:'合約交易',
        micro:'秒合約交易',
        myshop:"我的商鋪",
        assets:'我的資產',
        help:'幫助中心',
        login:"登錄",
        sign:'註冊',
        accountSet:'帳戶設定',
        tradeLog:'交易日誌',
        receiveSet:'收款設置',
        identify:'身份認證',
        jchange:'幣幣兌換',
        logout:'退出登錄',
        themedark:'夜間模式',
        themeday:'日間模式',
    },
    // 登錄註冊
    lg:{
        login:'登錄',
        register:'註冊',
    },
    // 首頁
    home:{
        vol:'24H量',
        c01:'全球領先的數字資產交易平臺',
        c02:'為全球超過130個國家的數百萬用戶提供安全、可信賴的數字資產交易及資產管理服務',
        c03:'安全可信賴',
        c04:'5 年數字資產金融服務經驗',
        c05:'專業分布式架構和防 DDOS 攻擊系統',
        c06:'全球生態布局',
        c07:'多個國家設立本土化交易服務中心',
        c08:'打造多業務形態為壹體的區塊鏈生態圈',
        c09:'用戶至上',
        c10:'建立先行賠付機制',
        c11:'設立投資者保護基金',
        c12:'隨時隨地 多平臺終端交易',
        c13:'覆蓋iOS、Android、Windows多個平臺，支持全業務功能',
        sweep:'掃碼下載',
        android:'Android',
        pinput:'請輸入你的郵箱或手機號',
        atrade:'注册一個OMGFIN全球站帳號開始交易旅程'
    },
    // 底部
    foo:{
        about:'關於我們',
        support:'用戶支持',
        contact:'聯系我們',
        qq:'客服QQ',
        email:'聯系郵箱',
    },
    // 行情
    market:{
		handicap:"盤口",
        exchange:'幣幣',
        selfmarket:'自選',
        allmarket:'全部行情',
        symbol:'交易對',
        newprice:'最新價',
        change:'漲幅',
        highprice:'最高價',
        lowprice:'最低價',
        vol:'24H量',
    },
    // 公共交易
    td:{
        buy:'購買',
        sell:'出售',
        currency:'幣種',
        num:'數量',
        time:'時間',
        limit:'限額',
        price:'單價',
        method:'支付方式',
        total:'總額',
        inwant:'請輸入欲',
        do:'操作',
        more:'加載更多',
        nomore:'沒有更多了',
        nodata:'暫無數據',
        trade:'交易',
        buynum:'購買數量',
        sellout:'賣出',
        buyin:'買入',
        all:'全部',
        allbuy:'全部買入',
        allsell:'全部賣出',
        buytotal:'請輸入欲購買總額',
        selltotal:'請輸入欲出售總額',
        buyallnum:'請輸入欲購買數量',
        sellallnum:'請輸入欲出售數量',
        tradeTotal:'交易總額',
        doceil:'秒後自動取消',
        place:'下單',
        waitpay:'待付款',
        paycode:'付款碼',
        finished:'已完成',
        ceiled:'已取消',
        payed:'已付款',
        nofinish:'未完成',   
        buyer:'買家',
        seller:'賣家',
        callWay:'聯系方式',
        placeTime:'下單時間',
        renum:'參考號',
        canceil:'取消',
        confirm:'確認',
        pwd:'請輸入交易密碼',
        coincode:'貨幣單位',
        pcoin:'請選擇貨幣單位'
    },
    // 法幣交易
    fat:{
        // LegalPayDetail
        orderLog:'訂單記錄',
        fatdLog:'法幣交易記錄',
        shoper:'商家',
        faLog:'法幣交易記錄',
        tdType:'交易類型',
        odStatus:'訂單狀態',
        pwaitPay:'請等待買家付款',
        odFinish:'訂單已完成',
        odCeil:'訂單已取消',
        odPay:'已付款，請仔細查看支付信息',
        tdCeil:'取消交易',
        pCeil:'如您已向賣家付款請千萬不要取消交易',
        paySure:'付款確認',
        pdopay:'請確認您已向賣家付款',
        badClick:'惡意點擊將直接凍結賬戶',
        receivePay:'收款確認',
        payReceive:'請確認買家已向您付款',
        receivePays:'確認已收款',
        // LegalPay
        payPlease:'請付款',
        tdPrice:'交易單價',
        tdNum:'交易數量',
        payinfo:'付款信息',
        banknum:'銀行賬戶',
        realName:'真實姓名',
        shoperZname:'商家支行',
        shoperNum:'商家賬戶',
        odCeil:'取消訂單',
        imPay:'我已付款,點擊確認',
        // LegalSeller
        register_time:'註冊時間',
        odtotal:'總成單',
        odmonth:'30日成單',
        odfinish:'完成單',
        odrate:'完成率',
        submit:'發布',
        phone:'手機',
        mysell:'我的出售',
        mybuy:'我的求購',
        realAuth:'實名認證',
        advAuth:'高級認證',
        linebuy:'在線購買',
        linesell:'在線出售',
        tipPay:'請在24小時內聯系商家付款，超出24小時將自動取消',
        notlow:'不能低於最低限額',
        nothigh:'不能超出最大限額',
        notnum:'不能超出最大數量',
        // LegalShopDetail
        type:'類型',
        status:'狀態',
        seeOrder:'查看訂單',
        withdraw:'撤回',
        abnormal:'異常',
        lowershelf:'下架',
        protection:'維權中',
		apply:'申請維權',
        psType:'請選擇類型',
        pselect:'請選擇',
        alipay:'alipay',
        wechat:'line',
        bank:'銀行卡',
        minNum:'最小交易量',
        maxNum:'最大交易量',
        wantBuy:'求購',
        pnums:'請輸入數量',
        pmin:'請輸入最小交易量',
        pmax:'請輸入最大交易量',
        pnot:'最大交易量不能小於最小交易量',
        // MyLegalShops
        myshops:'我的店鋪',
        name:'名稱',
        fiatSub:'所屬法幣',
        shoper_balance:'商家余額',
        enterShop:'進入店鋪',
        // shop_legal_pay_detail
        payedWait:'已付款，等待核實後確認',
        yes:'是',
		no:'否',
		sd:'鎖定餘額',
		journal:'餘額日誌',
		business:'商家',
		user:'用戶',
        backdone:'已撤回',
        busbalance:'商家餘額',
		userbalance:'用戶餘額',
    },
    ctc:{
        ctc:'C2C',
        myRelease:'我發布的C2C',
        myTrade:'我交易的C2C',
        and:'對',
        balance:'余額',
        buynum:'買入量',
        sellnum:'賣出量',
        bankTransfer:'銀行轉賬',
        payim:'必須本人支付',
        pbuyNum:'請輸入買入數量',
        pprice:'請輸入單價',
        payway:'請選擇支付方式',
        psellNum:'請輸入賣出數量',
        suerePlace:'確認下單麽?',
        detail:'詳情',
        payinfo:'付款信息',
        Payee:'收款人',
        total:'總額',
        name:'姓名',
        cardnum:'卡號',
        receivePay:'確認已收款',
        ceilConfirm:'確認取消交易？',
        paySeller:'請確認您已向賣家付款,惡意點擊將被凍結賬戶',
        payBuyer:'請確認您已收買家付款信息',
        account:'賬號',
        sellerPay:'請確認買家已向您付款？',
        payattion:'付款確認後請盡快向賣家付款,惡意點擊將直接凍結賬戶',
        log:'c2c已完成订单'
    },
    // 合約
    lever:{
        nowentrust:'當前委托',
        hisentrust:'歷史委托',
        lvchi:'合約持倉',
        all:'全部',
        or:'或',
        gotrade:'開始交易',
        tdrecord:'交易記錄',
        dealed:'已成交',
        notdeal:'未成交',
        loading:'加載中',
        entotal:'委托總額',
        canuse:'可用',
        std:'市價交易',
        xtd:'限價交易',
        pprice:'請輸入價格',
        phand:'請輸入購買手數',
        phandsell:'請輸入出售手數',
        pwd:'密碼',
        ppwd:'請輸入交易密碼',
        psw:'交易密碼',
        equal:'等於',
        times:'倍',
        timed:'倍數',
        hand:'手',
        hands:'手數',
        ptimes:'請選擇倍數',
        phands:'請選擇手數',
        contractVal:'合約市值',
        bail:'保證金',
        canBail:'可用保證金',
        charge:'交易服務費',
        domore:'買入 (做多)',
        doshort:'賣出 (做空)',
        dmore:'做多',
        dshort:'做空',
        sureOd:'確認下單',
        noless:'手數不能低於',
        nomore:'手數不能高於',
        tdnum:'交易量',
        risk:'風險率',
        allloss:'持倉總盈虧',
        onehouse:'壹鍵平倉',
        type:'類型',
        entrustPrice:'委托價',
        openPrice:'開倉價',
        nowPrice:'當前價',
        styPrice:'止盈價格',
        stsPrice:'止損價格',
        openTime:'開倉時間',
        closeTime:'平倉時間',
        rate:'手續費',
        nightFee:'隔夜費',
        loss:'盈虧',
        setloss:'設置止盈止損',
        expectProfit:'預期盈利',
        expectLoss:'預期虧損',
        allClose:'全部平倉',
        moreClose:'只平多單',
        nullClose:'只平空單',
        sureClose:'確認平倉？',
        thanZearo:'設置的值必須大於0',
        listin:'掛單中',
        tdin:'交易中',
        closein:'平倉中',
        closed:'已平倉',
        revoked:'已撤銷',
        revokeOrder:'確認撤銷訂單麽？',
        ping:'平仓',
        revoke:'撤单',
        sureping:'确定平仓？',
        thanzone:'设置的值必须大于0'
    },
    // 幣幣
    cuy:{
        direction:'方向',
        total:'總計',
        price:'價格',
        sell:'賣',
        buy:'買',
        allStation:'全站交易',
        buyPrice:'買入價',
        buynum:'買入量',
        sellPrice:'賣出價',
        sellnum:'賣出量',
        tdPrice:'交易額',
        or:'或',
        tdStart:'開始交易',
        pbPrice:'請輸入買入價',
        pbNum:'請輸入買入量',
        psPrice:'請輸入賣出價',
        psNum:'請輸入賣出量',
        fixPrice:'限價交易',
        Mtrans:'市價交易',
        available:'可用',
        revoke:'撤銷',
        loading:'加載中',
        confirmCancel:'您確定要撤銷嗎？',
        confirm:'確定',
        cancel:'取消',
        nomore:'沒有更多數據了',
        evelPrice:'成交均價'
    },
    // 資產
    asset:{
		confirmhuazhuan:"是否確認劃轉？",
        assets:'資產',
        currency_account:'幣幣賬戶',
        lever_account:'合約賬戶',
        fince_account:'法幣賬戶',
        change_account:'交易賬戶',
        micro_account:'秒合約帳戶',
        miscroAccount: '秒合約帳戶',
        assets_hua:'資金劃轉',
        all_assets:'總資產折合',
        currency:'幣種',
        canuse:'可用',
        frezz:'凍結',
        conversion:'折合',
        charging:'充幣',
        withdraw:'提幣',
        address_bind:'綁定提幣地址',
        address_withdraw:'提幣地址管理',
        record:'記錄',
        address_charge:'充幣地址',
        address_width:'提幣地址',
        copy:'復制',
        ercode:'二維碼',
        reminder:'溫馨提示',
        notcharge:'請勿向上述地址充值任何非',
        ornone:'，否則資產將不可找回',
        support:'充幣僅支持simple send的方法，使用其他方法(send all) 的充幣暫時無法上賬，請諒解。',
        minnum:'最小提幣數量',
        ratenum:'手續費',
        havenum:'到賬數量',
        from:'從',
        to:'至',
        transfer:'劃轉',
        tfnum:'劃轉數量',
        ptfnum:'請輸入最低',
        dtfnum:'的劃轉數量',
        canbalance:'可用余額',
        sureConfirm:'確認劃轉',
        moneyRecord:'財務記錄',
        pNum:'請輸入劃轉數量',
        leverUse:'合約賬戶可用',
        legalUse:'法幣賬戶可用',
		changeUselg:'幣幣賬戶可用',
        changeUse:'交易賬戶可用',
        microUse:'秒合約帳戶可用',
        look:'查看',
        chargeRecord:'充幣記錄',
        status:'跟蹤狀態',
        noopen:'該功能暫未開放',
        enterAdderses:'請輸入提幣地址',
        enterNum:'請輸入提幣數量',
        lessMin:'輸入的提幣數量小於最小值',
        tips01:'請勿向上述地址充值任何其他資產，否則資產將不可找回。',
        tips02:'充幣僅支持simple send的方法，使用其他方法（send all）的充幣暫時無法上賬，請您諒解。',
        beizhu:'備註',
        pbeizhu:'請輸入備註',
        add:'添加',
        addressList:'地址列表',
        delete:'刪除',
        norec:'暫無記錄',
        selectCurrency:'請選擇幣種',
        chainType:"鏈類型"
    },
    // 賬戶設置
    set:{
        mycode2:'我的授權碼',
        copycode2:'複製授權碼',
        uaccont:'您的賬號安全等級:',
        strong:'強',
        middle:'中',
        weak:'弱',
        min:'低',
        heigh:'高',
        complete:'完善更多資料，保證賬號安全',
        mycode:'我的邀請碼',
        copycode:'復制邀請碼',
        bindphone:'綁定手機',
        bindemail:'綁定郵箱',
        loginpwd:'登錄密碼',
        noBind:'未綁定',
        binds:'綁定',
        bind:'去綁定',
        binded:'已綁定',
        net:'互聯網賬號存在被盜風險，建議您定期更改密碼以保護賬號安全。',
        reset:'修改',
        setPsw:'設置交易密碼，保障交易安全。',
        goSet:'去設置',
        bindAccount:'綁定兌換賬號',
        duihuan:'綁定賬號進行積分兌換',
        copysuccess:'復制成功',
        copyfail:'復制失敗',
        recopy:'請重新復制',
        account:'賬戶',
        detail:'詳情',
        val:'金額',
        forgetPsw:'忘記密碼',
        code:'驗證碼',
        getCode:'獲取驗證碼',
        setPsw:'設置密碼',
        enterPsw:'請輸入密碼',
        pswFalse:'兩次輸入的密碼不壹致',
        enterPswagain:'請再次輸入密碼',
        jsetPsw:'設定交易密碼',
        jenterPsw:'請輸入交易密碼',
        jenterPswagain:'請再次輸入交易密碼',
        enterAccount:'請輸入賬號',
        enterCode:'請輸入驗證碼',
        accountFalse:'您輸入的手機或郵箱賬號不符合規則!',
        second:'秒',
        sendCode:'發送驗證碼',
        sendsucc:'發送成功',
        enterPswTwo:'請輸入兩次密碼',
        rest:'剩余',
        yes: '是',
        no: '否',
        yorn: '是否設定交易密碼',
    },
    // 身份認證
    auth:{
        identity:'身份認證',
        name:'姓名',
        idcard:'身份證件',
        upimg:'請上傳證件照，第壹張為正面，第二張為反面,第三張為手持證件照正面照片。',
        submit:'提交',
        auditing:'審核中...',
        certified:'已認證!',
        pname:'請輸入姓名',
        pidcard:'請輸入證件號',
        pimg:'請上傳證件圖片!',
    },
    // 收款方式
    seting:{
        pmethod:'收款方式',
        truename:'真實姓名',
        opening:'開戶行名稱',
        bank:'銀行卡號',
        alipay:'telegram賬號',
        wename:'line昵稱',
        wechat:'line賬號',
        pname:'請輸入真實姓名',
        popen:'請輸入開戶行名稱',
        pcard:'請輸入銀行卡號',
        palipay:'請輸入telegram賬號',
        pwname:'請輸入line昵稱',
        pwaccount:'請輸入line賬號',
        pimg1:'line收款碼',
        pimg2:'telegram收款碼'
    },
    // 幫助中心
    news:{
        seeall:'查看全部',
        helpcenter:'幫助中心',
        back:'返回'


    },
    //登錄
    login:{
        welcome:'歡迎登錄',
        phoneLogin:'手機登錄',
        emailLogin:'郵箱登錄',
        account:'賬號',
        psw:'密碼',
        login:'登錄',
        nouser:'還不是OMGFIN的用戶？',
        goRegister:'立即註冊，在全球領先的數字資產交易平臺開始交易。',
        registerFree:'免費註冊',
        psw6:'密碼不能小於六位'
    },
    register:{
        register:'註冊',
        phoneRegister:'手機註冊',
        emailRegister:'郵箱註冊',
        country:'國籍',
        enterPhone:'請輸入手機號',
        enterEmail:'請輸入郵箱',
        psw16:'密碼在6-16位之間',
        inviteCode:'邀請碼',
        sel:'必填',
        sel2:'非必填',
        read:'我已閱讀並同意',
        xieyi:'《用戶協議》',
        tips01:'國籍信息註冊後不可修改，請務必如實選擇。',
        tips02:'驗證郵件可能會被誤判為垃圾郵件，請註意查收。',
        tips03:'請妥善保存您的OMGFIN賬號及登錄密碼。',
        tips04:'請勿和其他網站使用相同的登錄密碼。',
        emailFalse:'您輸入的郵箱不符合規則'
    },
    // 积分兑换
    jc:{
        title:'JC兌換數位資產BEAU平臺',
        balance:'余額',
        cannum:'可用JC數量',
        new:'最新價',
        exnum:'兌換數量',
        pnum:'請輸入JC數量',
        canex:'可兌換BEAU數量',
        exnow:'立即兌換',
        record:'兌換記錄',
        exprice:'兌換價格',
        extime:'兌換時間',
        not:'可用積分數量不足',
        usenum:'使用JC數量',
        out:'退出',
        gotd:'去交易'
    },
    coin:{
        manage:'理財',
        total:'總存幣',
        bao:'存幣寶',
        mybao:'我的存幣',
        profit:'預計收益',
        cuntime:'存幣時間',
        endtine:'到期時間'
    },
    team:{
        myteam:'我的團隊',
        ztnum:'直推人數',
        activenum:'團隊活躍人數',
        profit:'收益',
        back:'返傭',
        cblog:'充幣記錄',
        bblog:'幣幣記錄',
    },
     // k线
     kline: {
        text1: '分時',
        text2: '1分鐘',
        text3: '5分鐘',
        text4: '15分鐘',
        text5: '30分鐘',
        text6: '1小時',
        text7: '1天',
        text8: '1周',
        text9: '1月',
    },
    // 秒合约
    miscro: {
        trade: '交易中',
        buyPrice: '購買價',
        finshPrice: '成交價',
        loss: '預計盈虧',
        times: '倒數計時',
        mode: '交易模式',
        num: '開倉數量',
        rate: '盈利率',
        up: '買漲',
        down: '買跌',
        openNum: '請輸入開倉數量',
        success: '下單成功！',
        c2c: "C2C帳戶",
        complaint: "投訴建議",
        reply: "請寫下您的問題，我們將儘快回復您…",
        complaintList: "投訴建議清單",
        complaintReply: "回復：",
        complaintDescription: "請輸入描述內容",
        resetpwd: "修改密碼",
        foundedOn: "創建於",
        commonProblem: "常見問題",
        statement: "解釋說明",
        about: "關於OMGFIN",
        everyone: "人人都是CEO",
        program: "OMGFIN全球合夥人計畫",
        program2: "合夥人計畫",
        myMine: "我的礦場：",
        friend: "我的礦友：",
        myRank: "我的等級：",
        accumulated: "累計傭金：",
        copyLinks: "複製推廣連結",
        moneyVein: "人脈變錢脈",
        example: "傭金示例",
        enterQuantity: "請輸入數量",
        contractBalance: "合約帳戶餘額",
        submitRepeatedly: "正在提交中，請不要反復提交",
        alipayCode: "telegram",
        wechatCode: "line付款碼",
        realPrice: "實时價格",
        currencyExchange: "兌出幣種",
        currencyExchangeIn: "兌入幣種",
        cashableBalance: "可兌出餘額：",
        minimumCashable: "最小可兌出：",
        maximumCashable: "最大可兌出：",
        automaticallys: "點擊兌換之後將自動完成，不能返回",
        match: "兌",
        title: "資產兌換",
        holdAssets: "持有資產",
        dangerousCurrency: "持險生幣",
        convertibleQuantity: "可兌換數量",
        currencyExchanges: "幣幣兌換率：",
        insuranceCurrency: "保險幣種",
        insuranceType: "保險類型",
        contractAsset: "合約資產保險額",
        warehouses: "保險倉數量",
        availableAssets: "可用資產：",
        insuredAssets: "受保資產：",
        insuredAssets1: "受保資產",
        insuranceAssets: "保險資產：",
        purchaseInsurance: "申購保險",
        insuranceClaims: "保险理赔",
        insuranceCancellation: "保險解約",
        coinWallet: "保險幣錢包",
        bmbWallet: "HAP錢包",
        cumulativeCoins: "累計生幣：",
        availableQuantity: "可用數量：",
        rawCurrency: "生幣記錄",
        contractInsurance:"合約保險",
        tenThousand:"萬",
        runningLow:"餘額不足",
        purchase:"你輸入的數量不符合規則，你的購買額度在",
        reach:"到",
        between:"之間",
        onlyEnter:"你只能輸入",
        integersBetween:"之間的整數",
        notReturned:"點擊申購保險，視為詳細瞭解保險條約並且同意保險倉自動生效，不能返回。",
        settled:"受保資產虧損至無法下單時，保險理賠",
        profitable:"倍，當資產盈利",
        terminated:"時，保險自動解約。",
        automatically:"當受保資產虧損50%時，必須申請保險理賠，否則無法交易，當盈利100%時，保險自動解約，保險倉每天只允許賠付兩次，超過兩次，t+1賠付",
        termination:"保險解約後，受保資產方可兌換，解約後視為違約，保險倉自動清零。",
        just:"正",
        back:"反",
        lowestNumber:"數量最低為",
        confirmExchange:"確認兌換嗎？",
        contractValuation:"合約帳戶資產估值",
        secondValuation:"秒合約帳戶資產估值",
        falshValuation:"閃兌帳戶資產估值",
        c2cValuation:"C2C帳戶資產估值",
        recordWithdrawal:"充提幣記錄",
        category:"類別",
        safetyCenter:"安全中心",
        safeText1:"註冊、修改密碼，及安全設置時用以收取驗證簡訊",
        safeText2:"互聯網帳號存在被盜風險，建議您定期更改密碼以保護帳戶安全。",
        flashTrading:"閃兌交易",
        assetCenter:"資產中心",
        promotionCode:"我的推廣碼",
        loginAgain:"登入過時，請重新登入",
        text10:"基於HAP的實时價格",
        text11:"授權碼"
    }
}


// WEBPACK FOOTER //
// ./src/lang/hk.js